import React, { useEffect, useState } from "react";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { toRemission } from "../../../_services/order.service";
import { enterKeyHandler } from "../../../_utils/keyboard_events";
import { message } from "antd";

var times = 0;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

export default function DepathModal({ modalData, openModal, handleCloseModal, handleProductCheckboxChange, selectedProductsRight, handleInputAddInfoChange, selectedClients, toggleClientSelection, inputValues, addInfoOrders, handleInputChange, handleSelectChange, selectValues, setOpenPDF, setPDF, showRemisionButton, handleRemisionButtonClick, loadRemisionModalData, handleBoxProducts, boxProducts}){

  const [focused, setFocused] = useState(false);
    
    useEffect(() => {
      loadRemisionModalData();
    }, []);

    const sendData = () => {
      const data = document.getElementById('barcode-input-desp').value;
      toRemission(data)
      .then(json => {
        loadRemisionModalData();
      })
      .catch(err => {
          message.error(err.emssage);
      });
      document.getElementById('barcode-input-desp').value = '';
    }

    return(
        <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              {
                    focused ?  
                    <div style={{ fontWeight: 'bold', fontSize: '1.3em', color: 'green' }}>LISTO PARA PISTOLEAR</div>
                    : 
                    <div style={{ fontWeight: 'bold', fontSize: '1.3em', color: 'red' }}>INGRESA EN EL CAMPO DE TEXTO</div>
                }
                <input
                    id="barcode-input-desp"
                    autoFocus
                    type="text"
                    onFocus={() => {
                        setFocused(true);
                    }}
                    onBlur={() => {
                        setFocused(false);
                    }}
                    onKeyUp={(e) => {
                        enterKeyHandler(e, () => {
                            sendData();
                        })
                    }}
                />
              </div>
            </Grid>
            <Grid item xs={6}>
              {/* PANEL IZQUIERDO */}
              <h2 style={{ textAlign: 'center' }}>Despachos</h2>
              <p></p>

              <div style={{ maxHeight: '400px', overflowY: 'scroll' }}>
                {Object.keys(modalData).map((clientName) => (
                  <div key={clientName} style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                      
                      <h3 style={{ margin: '0' }}>Órden(es) del cliente: {clientName}</h3>
                    </label>

                    <ul>
                      {modalData[clientName].orders.map((order, orderIndex) => (
                        <li key={`${clientName}-order-${orderIndex}`}>
                          <strong>Orden ID:</strong> {order.id}
                          <ul>
                            {order.ordersDetail.map((od, detailIndex) => (
                              <li key={`${clientName}-order-${orderIndex}-detail-${detailIndex}`}>
                                <input
                                    type="checkbox"
                                    id={od.uuid}
                                    onChange={(e) => handleProductCheckboxChange(od.uuid,e.target.checked)}
                                    checked={od.checked === 1 ? true : false}
                                    style={{ marginRight: '10px', verticalAlign: 'middle' }}
                                  />
                                <strong>Ref. producto: </strong> {od.productPrice.product.ref} |   <strong>Cantidad:</strong> {od.quantity} {od.type_quantity}
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              
            </Grid>
            <Grid item xs={12} md={6}>
              <h2 style={{ textAlign: 'center' }}>Remisionados</h2>
              <p></p>
              <RightPanel 
                selectedProductsRight={selectedProductsRight} 
                handleInputAddInfoChange={handleInputAddInfoChange} 
                selectedClients={selectedClients}
                toggleClientSelection={toggleClientSelection}
                inputValues={inputValues}
                handleCloseModal={handleCloseModal}
                addInfoOrders={addInfoOrders}
                handleInputChange={handleInputChange}
                handleRemisionButtonClick={handleRemisionButtonClick}
                handleSelectChange={handleSelectChange}
                selectValues={selectValues}
                setOpenPDF={setOpenPDF}
                setPDF={setPDF}
                showRemisionButton={showRemisionButton}
                boxProducts={boxProducts}
                handleBoxProducts={handleBoxProducts}
            />
            </Grid>
          </Grid>
        </Box>
      </Modal>
    );
}

const RightPanel = ({ selectedProductsRight, handleInputAddInfoChange, selectedClients, toggleClientSelection, inputValues, handleInputChange, selectValues, handleSelectChange, addInfoOrders, showRemisionButton, setPDF, setOpenPDF, handleRemisionButtonClick, handleCloseModal,handleBoxProducts, boxProducts }) => {  
  
  return (
      <div style={{ maxHeight: '400px', overflowY: 'scroll' }}>
        {Object.keys(selectedProductsRight).map((clientName) => (
          <div key={clientName} style={{ marginBottom: '20px' }}>
            <label style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
              {Object.keys(selectedProductsRight[clientName]).length > 1 && (
                <input
                  type="checkbox"
                  id={clientName}
                  checked={selectedClients[clientName] || false}
                  onChange={() => toggleClientSelection(clientName)}
                  style={{ marginRight: '10px', verticalAlign: 'middle' }}
                />
              )}
              <h3 style={{ margin: '0' }}>Órden(es) del cliente: {clientName}</h3>
            </label>
            <ul>
              {
              Object.keys(selectedProductsRight[clientName]).map((orderNumber) => (
                <li key={`${clientName}-order-${orderNumber}`}>
                  <strong>Número de orden:</strong> {orderNumber} <input
                    type="number"
                    placeholder={`Cajas orden: ${orderNumber}`}
                    defaultValue={inputValues[orderNumber] || ''}
                    onChange={(e) => {
                      
                      handleInputChange(orderNumber,e.target.value);
                      
                    }}
                  /> <select
                      defaultValue={selectValues[orderNumber] || ''}
                      onChange={(e) => {
                        handleSelectChange(orderNumber,e.target.value);
                      }}
                  >
                    <option value="caja">Caja</option>
                    <option value="paquete">Paquete</option>
                  </select>  
                  <ul>
                    {selectedProductsRight[clientName][orderNumber].products.map((product, productIndex) => (
                      <li key={`${clientName}-order-${orderNumber}-product-${productIndex}`}>
                         <span style={{ marginRight: '10px' }}>
                          <strong>Ref. producto:</strong> {product.productPrice.product.ref} | <strong>Cantidad:</strong> {product.quantity} {product.type_quantity}
                        </span>
                        <input
                        type="number"
                        defaultValue={boxProducts[orderNumber]?.[product.uuid] || ''}
                        placeholder={`Ref. caja`}
                        style={{ width: '75px' }}
                        onChange={(e) => {
                          handleBoxProducts(orderNumber, product.uuid, e.target.value);
                        }}
                      />
                      </li>
                    ))}
                  </ul>

                  
                  <textarea  
                    placeholder={`informacion adicional para orden: ${orderNumber}`}
                    defaultValue={addInfoOrders[orderNumber]}
                    style={{ width: '67%', border: '1px solid #ccc', minHeight: '100px' }}
                    onChange={(e) => {
                      handleInputAddInfoChange(orderNumber,e.target.value);
                    }}
                  />
                </li>
              ))}
            </ul>
          </div>
        ))}
  
        {
        Object.keys(selectedProductsRight).length > 0 && (
          <div id='btn'>
            <Button variant="contained" color="primary" style={{ display: 'block', margin: '0 auto' }} 
              onClick={() => {
                document.getElementById('btn').innerHTML = '<div>Cargando...</div>';
                setTimeout(() => {
                  handleRemisionButtonClick();
                  handleCloseModal();
                }, 2000);
              }}
            >
              Remisionar
            </Button>
          </div>
        )
        }
      </div>
    );
};